import { DownloadItemType, DownloadVersionType } from "../types";

export function isDownloadVersionType(
  data: DownloadItemType
): data is DownloadVersionType {
  return Boolean(Object.prototype.hasOwnProperty.call(data, "build_number"));
}
